import cloneDeep from 'lodash.clonedeep';

export default {
  // Return a single item with the given id.
  find: state => id => cloneDeep({
    ...state.byId[id],
    id,
  }),

  // Return a list of items in the order of `allIds`.
  list: (state, getters) => state.allIds.map(id => ({
    ...getters.find(id),
    id,
  })),
};
